import { WhatsappLogo } from "@phosphor-icons/react";
import { contact } from "@/data/site";

export function WhatsAppButton() {
  const href = `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(contact.whatsappMessage)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-quote-button"
      aria-label="Request a quote on WhatsApp"
      className="fixed bottom-5 right-5 z-[70] inline-flex items-center gap-3 border border-industrial-black bg-industrial-yellow p-3 font-mono text-xs font-bold uppercase tracking-[0.16em] text-industrial-black shadow-[4px_4px_0_#111111] transition-all hover:-translate-y-1 hover:shadow-[6px_6px_0_#111111] sm:px-4 sm:py-3"
    >
      <WhatsappLogo size={22} weight="fill" /> <span className="hidden sm:inline">WhatsApp Quote</span>
    </a>
  );
}
